var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},[_c('div',{staticClass:"step-bar",style:({ width: `${_vm.completionPercentage}%` })}),_vm._v(" "),_vm._l((_vm.totalSteps),function(step){return _c('div',{key:step,staticClass:"step-indicator",class:{
      'completed': step < _vm.currentStep,
      'active': step == _vm.currentStep
    }},[(step == _vm.currentStep)?_c('illustration',{attrs:{"name":"sun"}}):_vm._e()],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }